var _a;
import { ESortOrder } from "@domains/features/Markets/AIF-PMS/dto";
import { EClientTier } from "@frameworks/shared-library/components/TransactionJourney/MutualFund/MutualFundConstant";
import StepOne from "@frameworks/shared-library/assets/images/features/Markets/Pms/step-one.svg";
import Second from "@frameworks/shared-library/assets/images/features/Markets/Pms/step-second.svg";
import Three from "@frameworks/shared-library/assets/images/features/Markets/Pms/step-three.svg";
export var NCDtabs = [
    {
        title: "All",
        eventKey: "1",
        eventCode: "1",
    },
    {
        title: "Focused",
        eventKey: "2",
        eventCode: "2",
    },
    {
        title: "Newly Added",
        eventKey: "3",
        eventCode: "3",
    },
];
export var Structuredtabs = [
    {
        title: "All",
        eventKey: "0",
        eventCode: "0",
    },
    {
        title: "Focused",
        eventKey: "1",
        eventCode: "1",
    },
    {
        title: "High Returns",
        eventKey: "2",
        eventCode: "2",
    },
    {
        title: "Upcoming Maturity",
        eventKey: "3",
        eventCode: "3",
    },
];
export var BuyNCDNuvamatabs = [
    {
        title: "Buy NCDs for Nuvama",
        eventKey: "1",
        eventCode: "1",
    },
];
export var BuySPsNuvamatabs = [
    {
        title: "Buy SPs for Nuvama",
        eventKey: "0",
        eventCode: "0",
    },
];
export var EHoldingTypeNCD;
(function (EHoldingTypeNCD) {
    EHoldingTypeNCD["RTGS"] = "RTGS";
    EHoldingTypeNCD["Cheque"] = "Cheque";
    EHoldingTypeNCD["NetBanking"] = "NetBanking";
})(EHoldingTypeNCD || (EHoldingTypeNCD = {}));
export var tierBorderClasses = (_a = {},
    _a[EClientTier.DIAMOND] = "border-dark-orchid",
    _a[EClientTier.BLACK] = "border-black",
    _a[EClientTier.PLATINUM] = "border-wild-blue-yonder",
    _a[EClientTier.GOLD] = "border-golden-rod1",
    _a[EClientTier.SILVER] = "border-quick-silver1",
    _a[EClientTier.BRONZE] = "border-coconut",
    _a[EClientTier.BLUE] = "border-blue-de-france",
    _a);
export var paymentOptions = ["RTGS", "Cheque", "NetBanking"];
export var FilterSortList = [
    { name: "Name - A to Z", value: "Name", type: ESortOrder.ASCENDING },
    { name: "Name - Z to A", value: "NameDSC", type: ESortOrder.DESCENDING },
    {
        name: "1 Year CAGR Returns - High to Low",
        value: "Year1",
        type: ESortOrder.ASCENDING,
    },
    {
        name: "3 Year CAGR Returns - High to Low",
        value: "Year3",
        type: ESortOrder.ASCENDING,
    },
    {
        name: "5 Year CAGR Returns - High to Low",
        value: "Year5",
        type: ESortOrder.ASCENDING,
    },
    {
        name: "AUM - Highest to Lowest",
        value: "FundSize",
        type: ESortOrder.ASCENDING,
    },
];
export var stepsNcd = [
    {
        img: StepOne,
        title: "Step 1",
        description: "Capture Consent Intent",
        details: "Quickly capture client consent with ease, ensuring a smooth approval process.",
    },
    {
        img: Second,
        title: "Step 2",
        description: "Payment Completion",
        details: "Send payment links instantly, making it simple for clients to complete their payment.",
    },
    {
        img: Three,
        title: "Step 3",
        description: "Track Status Updates",
        details: "Keep clients informed with real-time updates, making progress easy to follow in Orderbook.",
    },
];
export var pdfContentType = "application/pdf";
export var SUPPORTED_FORMATS = [
    "image/jpeg",
    "image/png",
    "image/jpg",
    "application/pdf",
];
export var ACCEPTED_FORMATS = SUPPORTED_FORMATS.join(", ");
export var FILE_EXTENSION = ["png", "jpg", "jpeg", "gif"];
export var FilterSortListOtc = [
    {
        name: "Name - A to Z",
        value: "display_name-asc",
        type: false,
        filterValue: "display_name",
    },
    {
        name: "Name - Z to A",
        value: "display_name-desc",
        type: true,
        filterValue: "display_name",
    },
    {
        name: "Maturity Date Remaining Period - High to Low",
        value: "maturity_Date-desc",
        type: true,
        filterValue: "maturitydate",
    },
    {
        name: "Maturity Date Remaining Period - Low to High",
        value: "maturity_Date-asc",
        type: false,
        filterValue: "maturitydate",
    },
    {
        name: "Coupon - High to Low",
        value: "coupon-desc",
        type: true,
        filterValue: "coupon_rate",
    },
    {
        name: "Coupon - Low to High",
        value: "coupon-asc",
        type: false,
        filterValue: "coupon_rate",
    },
    {
        name: "Price Range per Qty. - High to Low",
        value: "price-range-desc",
        type: true,
        filterValue: "price_range",
    },
    {
        name: "Price Range per Qty. - Low to High",
        value: "price-range-asc",
        type: false,
        filterValue: "price_range",
    },
    {
        name: "Payout Freq. - Highest to Lowest",
        value: "payout-desc",
        type: true,
        filterValue: "interest_frequency",
    },
    {
        name: "Payout Freq. - Lowest to Highest",
        value: "payout-asc",
        type: false,
        filterValue: "interest_frequency",
    },
    {
        name: "Avl. Qty - Highest to Lowest",
        value: "avl-qty-desc",
        type: true,
        filterValue: "avl_qty",
    },
    {
        name: "Avl. Qty - Lowest to Highest",
        value: "avl-qty-asc",
        type: false,
        filterValue: "avl_qty",
    },
];
export var tabData = [
    {
        eventKey: "261",
        title: "Mutual Fund",
        url: "https://vamauat.nuvamawealth.com/rmjourneys/dashboard/activity-book?productCode=56&categoryCode=261",
    },
    {
        eventKey: "268",
        title: "PMS",
        url: "https://vamauat.nuvamawealth.com/rmjourneys/dashboard/activity-book?productCode=56&categoryCode=268",
    },
    {
        eventKey: "279",
        title: "ETF",
        url: "https://vamauat.nuvamawealth.com/rmjourneys/dashboard/activity-book?productCode=56&categoryCode=279",
    },
    {
        eventKey: "292",
        title: "Structured Products",
        url: "https://vamauat.nuvamawealth.com/rmjourneys/dashboard/activity-book?productCode=56&categoryCode=292",
    },
    {
        eventKey: "293",
        title: "AIF",
        url: "https://vamauat.nuvamawealth.com/rmjourneys/dashboard/activity-book?productCode=56&categoryCode=293",
    },
    {
        eventKey: "335",
        title: "INVITs",
        url: "https://vamauat.nuvamawealth.com/rmjourneys/dashboard/activity-book?productCode=56&categoryCode=335",
    },
    {
        eventKey: "336",
        title: "NFO",
        url: "https://vamauat.nuvamawealth.com/rmjourneys/dashboard/activity-book?productCode=56&categoryCode=336",
    },
];
export var tabDataFixedIncome = [
    {
        eventKey: "256",
        title: "Bonds",
        url: "https://vamauat.nuvamawealth.com/rmjourneys/dashboard/activity-book?productCode=54&categoryCode=256",
    },
    {
        eventKey: "257",
        title: "NCD",
        url: "https://vamauat.nuvamawealth.com/rmjourneys/dashboard/activity-book?productCode=54&categoryCode=257",
    },
    {
        eventKey: "301",
        title: "RBI Bonds",
        url: "https://vamauat.nuvamawealth.com/rmjourneys/dashboard/activity-book?productCode=54&categoryCode=301",
    },
    {
        eventKey: "339",
        title: "Commercial Paper",
        url: "https://vamauat.nuvamawealth.com/rmjourneys/dashboard/activity-book?productCode=54&categoryCode=339",
    },
    {
        eventKey: "302",
        title: "Corporate FD",
        url: "https://vamauat.nuvamawealth.com/rmjourneys/dashboard/activity-book?productCode=54&categoryCode=302",
    },
    {
        eventKey: "300",
        title: "Capital Gains Bond (54 EC)",
    },
    {
        eventKey: "340",
        title: "Warrant",
        url: "https://vamauat.nuvamawealth.com/rmjourneys/dashboard/activity-book?productCode=54&categoryCode=340",
    },
];
export var tabDataEquity = [
    {
        eventKey: "338",
        title: "IDR",
    },
    {
        eventKey: "350",
        title: "Smallcase",
    },
    {
        eventKey: "337",
        title: "SLBM",
    },
    {
        eventKey: "278",
        title: "Unlisted Shares",
    },
    {
        eventKey: "341",
        title: "Preference Shares",
    },
    {
        eventKey: "342",
        title: "SMTF",
    },
    {
        eventKey: "343",
        title: "IPO",
    },
    {
        eventKey: "344",
        title: "OFS",
    },
    {
        eventKey: "345",
        title: "Rights",
    },
    {
        eventKey: "346",
        title: "Buyback",
    },
    {
        eventKey: "277",
        title: "Listed Shares",
    },
];
export var refundTypeId = [2, 7, 13];
export var validateOptions = [
    {
        value: "mobile",
        display: "Mobile No.",
    },
    {
        value: "dob",
        display: "Date of Birth",
    },
    {
        value: "email",
        display: "Email",
    },
];
